import React, { useState, useEffect, useRef, useCallback } from 'react';
import styles from '../App.module.css';
import api from '../api/axios';
import { FaTimes, FaPen } from 'react-icons/fa';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/notifications.css';
import { isAuthenticated } from '../index';
import notifications from '../components/notifications';
import ModalFinalizar from "../components/ModalFinalizar";
import ListaFormularios from "../components/ListaFormularios";

function Producao() {
  const [notificationType, setNotificationType] = useState(0);
  const { userPermission, userStatus, userCpf } = isAuthenticated();

  const [filtroVendedorProd, setFiltroVendedorProd] = useState(0);
  const [filtroProdutor, setFiltroProdutor] = useState(0);
  const [filtroStatusProd, setFiltroStatusProd] = useState(0);

  const [usersListProd, setUsersListProd] = useState([]);
  const [filteredDataProd, setFilteredDataProd] = useState([]);
  const [vendedoresList, setVendedoresList] = useState([]);
  const [produtoresList, setProdutoresList] = useState([]);

  const [isModalOpenAguardando, setIsModalOpenAguardando] = useState(false);
  const [isModalOpenFinalizado, setIsModalOpenFinalizado] = useState(false);
  const [isModalOpenForm, setIsModalOpenForm] = useState(false);
  const [isModalOpenAnalise, setIsModalOpenAnalise] = useState(false);

  const [inputValue, setInputValue] = useState('');
  const [currentUserId, setCurrentUserId] = useState(null);
  const [login, setLogin] = useState("");
  const [senha, setSenha] = useState("");
  const [currentFormContent, setCurrentFormContent] = useState('');
  const [currentFormId, setCurrentFormId] = useState('');
  const [searchTerm, setSearchTerm] = useState("");

  const textareaRef = useRef(null);

  const origin = window.location.origin;

  useEffect(() => {
    if (notificationType && notifications[notificationType]) {
      notifications[notificationType]();
      setNotificationType(0);
    }
  }, [notificationType]);

  const getUsers = useCallback(async () => {
    try {
      const res = await api.get(
        `/usuariosComFormularios?userPermission=${userPermission}&CPF=${userCpf}`
      );
      const { users } = res.data;

      if (!users || !Array.isArray(users)) {
        console.error('Erro: `users` não é um array válido:', users);
        setUsersListProd([]);
        setFilteredDataProd([]);
        NotificationManager.error('Resposta inválida ao carregar usuários.', 'Erro');
        return;
      }

      setUsersListProd(users);
      setFilteredDataProd(users);
    } catch (error) {
      console.error('Erro ao buscar usuários e formulários:', error);
      NotificationManager.error('Não foi possível carregar usuários e formulários.', 'Erro');
    }
  }, [userPermission, userCpf]);

  const getVendedoresProdutores = useCallback(async () => {
    try {
      const resVendedoresProdutores = await api.get('/vendedores-produtores');

      if (
        resVendedoresProdutores.data &&
        Array.isArray(resVendedoresProdutores.data.data)
      ) {
        const users = resVendedoresProdutores.data.data;
        setVendedoresList(users.filter((user) => user.is_vendedor === 1));
        setProdutoresList(users.filter((user) => user.is_produtor === 1));
      } else {
        console.error('Formato inesperado da resposta:', resVendedoresProdutores.data);
        NotificationManager.error('Erro ao carregar vendedores e produtores.', 'Erro');
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
      NotificationManager.error('Erro ao carregar dados.', 'Erro');
    }
  }, []);

  useEffect(() => {
    if (userPermission === 2) {
      setFiltroProdutor(userStatus);
      setFiltroStatusProd(-2);
    }

    getVendedoresProdutores();
    getUsers();
  }, [getUsers, getVendedoresProdutores, userPermission, userStatus]);

  const normalize = (text) =>
    (text ?? "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\p{L}\p{N}]+/gu, "")
      .toLowerCase();

  const flattenValues = useCallback((val) => {
    if (val === null || val === undefined) return "";
    if (Array.isArray(val)) return val.map(flattenValues).join(" ");
    if (typeof val === "object") return Object.values(val).map(flattenValues).join(" ");
    return String(val);
  }, []);

  useEffect(() => {
    const normalizedSearch = normalize(searchTerm);

    const next = usersListProd.filter((user) => {
      const statusMatch =
        filtroStatusProd === 0 ||
        user.produzirStatus === filtroStatusProd ||
        (filtroStatusProd === -2 &&
          (user.produzirStatus === 0 || user.produzirStatus === 2));

      const vendedorMatch =
        filtroVendedorProd === 0 || user.vendedor === filtroVendedorProd;

      const produtorMatch =
        filtroProdutor === 0 || user.produtor === filtroProdutor;

      const loginNorm = normalize(user.login || "");
      const vendedorNorm = normalize(user.vendedor || "");
      const produtorNorm = normalize(user.produtor || "");
      const nomeCliente = normalize(user.nomeCompleto || user.Nome || "");
      const contatoCliente = normalize(user.contato || "");

      const forms = Array.isArray(user.formularios) ? user.formularios : [];
      const formsBlob = forms
        .map((f) => {
          const ds160 = normalize((f.ds160_id ?? "").toString());
          let data = {};
          try {
            data = JSON.parse(f.formularioData || "{}");
          } catch {
            data = {};
          }
          const flat = normalize(flattenValues(data));
          return [ds160, flat].join(" ");
        })
        .join(" ");

      const haystack = [
        loginNorm,
        vendedorNorm,
        produtorNorm,
        nomeCliente,
        contatoCliente,
        formsBlob,
      ].join(" ");

      const searchMatch = !normalizedSearch || haystack.includes(normalizedSearch);

      return statusMatch && vendedorMatch && produtorMatch && searchMatch;
    });

    setFilteredDataProd(next);
  }, [
    usersListProd,
    filtroVendedorProd,
    filtroProdutor,
    filtroStatusProd,
    searchTerm,
    flattenValues,
  ]);

  useEffect(() => {
    const someFilterApplied =
      (searchTerm && searchTerm.trim().length > 0) ||
      filtroVendedorProd !== 0 ||
      filtroProdutor !== 0 ||
      filtroStatusProd !== 0;

    if (someFilterApplied && filteredDataProd.length === 0) {
      NotificationManager.info(
        'Nenhum resultado encontrado. Ajuste a busca ou os filtros.',
        'Sem resultados'
      );
    }
  }, [filteredDataProd, searchTerm, filtroVendedorProd, filtroProdutor, filtroStatusProd]);

  const handleClickAguardando = async (user) => {
    setInputValue(user.aguardando || "");
    setCurrentUserId(user.produzirId);
    setIsModalOpenAguardando(true);
  };

  const handleClickFinalizado = async (user) => {
    setCurrentUserId(user.produzirId);
    setInputValue(user.aguardando || "");
    setLogin(user.login || "");
    setSenha(user.senha || "");
    setIsModalOpenFinalizado(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSubmitAguardando = async () => {
    try {
      const response = await api.post('/updateStatusProducao', {
        id: currentUserId,
        aguardando: inputValue,
        status: 2,
      });

      if (response.status === 200) {
        setIsModalOpenAguardando(false);
        setInputValue("");
        getUsers();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };

  const handleSubmitFinalizado = async () => {
    try {
      const response = await api.post('/updateStatusProducao', {
        id: currentUserId,
        aguardando: inputValue,
        status: 1,
        login: String(login),
        senha: String(senha),
      });

      if (response.status === 200) {
        setIsModalOpenFinalizado(false);
        setInputValue("");
        getUsers();
      } else {
        console.error('Erro ao atualizar o status e o texto "aguardando"');
      }
    } catch (error) {
      console.error('Erro na solicitação de atualização:', error);
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(
        textareaRef.current.scrollHeight,
        400
      )}px`;
    }
  }, [inputValue]);

  const renderFormContent = (content) => {
    try {
      const parsedContent = typeof content === "string" ? JSON.parse(content) : content;

      const informed = [];
      const notInformed = [];

      Object.entries(parsedContent || {}).forEach(([key, value]) => {
        const isEmpty =
          value === null ||
          value === undefined ||
          value === "" ||
          (Array.isArray(value) && value.length === 0) ||
          (typeof value === "object" &&
            !Array.isArray(value) &&
            Object.keys(value).length === 0);

        if (isEmpty) {
          notInformed.push(key);
        } else {
          const displayValue = Array.isArray(value)
            ? value.join(", ")
            : typeof value === "object"
              ? JSON.stringify(value)
              : value;

          informed.push(
            <div key={key} style={{ marginBottom: "10px" }}>
              <strong>{key}:</strong> {displayValue}
            </div>
          );
        }
      });

      return (
        <div>
          <div>
            <h3>Informações Preenchidas</h3>
            {informed.length > 0 ? informed : <p>Nenhuma informação preenchida.</p>}
          </div>

          {notInformed.length > 0 && (
            <div
              style={{
                marginTop: "20px",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            >
              <h3>Perguntas Não Informadas</h3>
              {notInformed.map((key) => (
                <div key={key} style={{ marginBottom: "5px" }}>
                  <strong>{key}</strong>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    } catch (error) {
      console.error("Erro ao renderizar conteúdo do formulário:", error);
      return <div>Erro ao exibir o conteúdo</div>;
    }
  };

  const groupColors = ['#8BAED3', '#F29098', '#808EA3', '#C0ECAE'];

  return (
    <div className={styles.app}>
      <NotificationContainer />

      <div style={{ width: "100%", maxWidth: "600px", display: "flex", marginBottom: "-40px" }}>
        <div
          className="filter-box"
          style={{ width: "15%", display: "flex", padding: "20px", alignItems: "center" }}
        >
          <label style={{ width: "100%", fontWeight: "600", fontSize: "1.2rem" }}>
            FILTRO:
          </label>
        </div>

        <div
          className="filter-box"
          style={{ width: "85%", display: "block", padding: "20px", alignItems: "center" }}
        >
          <div
            className="filter-container"
            style={{ width: "100%", display: "flex", justifyContent: "space-evenly" }}
          >
            <div className="filter-box" style={{ width: "45%", display: "block" }}>
              <select
                style={{ width: "100%", padding: "10px", borderRadius: "15px", backgroundColor: "white" }}
                onChange={(e) => {
                  setFiltroVendedorProd(e.target.value || 0);
                }}
                value={filtroVendedorProd}
                className={styles.inputStyleVendedor}
              >
                <option value="">Vendedor</option>
                {vendedoresList.map((v) => (
                  <option key={v.id} value={v.cpf}>
                    {v.nome} - {v.cpf}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-box" style={{ width: "45%", display: "block" }}>
              <select
                style={{ width: "100%", padding: "10px", borderRadius: "15px", backgroundColor: "white" }}
                onChange={(e) => {
                  setFiltroProdutor(e.target.value || 0);
                }}
                value={filtroProdutor}
                className={styles.inputStyleVendedor}
              >
                <option value="">Produtor</option>
                {produtoresList.map((p) => (
                  <option key={p.id} value={p.cpf}>
                    {p.nome} - {p.cpf}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.cadastroClienteContainer}>
        <div className="search-container" style={{ width: "100%", textAlign: "center" }}>
          <input
            type="text"
            placeholder="Buscar usuário..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "80%",
              padding: "10px",
              borderRadius: "20px",
              border: "1px solid #000",
              fontSize: "16px",
              backgroundColor: "#e0e0e0",
            }}
          />
        </div>

        <div style={{ width: "100%", display: "flex" }}>
          <div
            className="filter-box"
            style={{ width: "100%", display: "block", padding: "20px", alignItems: "center" }}
          >
            <select
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "15px",
                backgroundColor: "#e0e0e0",
              }}
              value={filtroStatusProd}
              onChange={(e) => setFiltroStatusProd(Number(e.target.value))}
            >
              <option value="0">Ativos</option>
              <option value="2">Aguardando</option>
              <option value="1">Finalizados</option>
            </select>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-evenly",
          }}
        >
          <div className={styles.topLegend} style={{ backgroundColor: "var(--corPrimaria)" }}>
            <span>ID DS-160</span>
          </div>
          <div className={styles.topLegend} style={{ backgroundColor: "#df022e" }}>
            <span>NOME</span>
          </div>
          <div className={styles.topLegend} style={{ backgroundColor: "var(--corPrimaria)" }}>
            <span>DATA</span>
          </div>
        </div>

        <div style={{ display: "flex", width: "100%" }}>
          <div className={`${styles.usersListContainer} ${styles.noscroll}`}>
            <ListaFormularios
              users={filteredDataProd.filter((user) => user.status !== 1)}
              groupColors={groupColors}
              onClickVer={async (user) => {
                try {
                  const res = await api.get(`/cliente/token-por-cliente/${user.clienteId}`);

                  if (res.data?.status && res.data?.token) {
                    window.location.href = `${origin}/formulario/${res.data.token}`;
                  } else {
                    window.location.href = `${origin}/formularios/${user.clienteId}`;
                  }
                } catch (error) {
                  console.error("Erro ao verificar token do cliente:", error);
                  window.location.href = `${origin}/formularios/${user.clienteId}`;
                }
              }}
              onClickFinalizar={handleClickFinalizado}
              onClickAguardar={handleClickAguardando}
              onClickAnalise={() => {
                setIsModalOpenAnalise(true);
              }}
              setCurrentFormContent={setCurrentFormContent}
              setCurrentFormId={setCurrentFormId}
              setIsModalOpenForm={setIsModalOpenForm}
              tipo="pendencias"
            />
          </div>
        </div>
      </div>

      {isModalOpenAguardando && (
        <div className={styles.modalProducao}>
          <div className={styles.modalContentProducao}>
            <h2>Observação do produtor</h2>
            <textarea
              ref={textareaRef}
              style={{
                width: "100%",
                minHeight: "50px",
                maxHeight: "400px",
                overflow: "auto",
                resize: "none",
              }}
              value={inputValue}
              onChange={handleInputChange}
            />
            <button type="button" onClick={handleSubmitAguardando}>
              Registrar
            </button>
            <button
              type="button"
              onClick={() => {
                setIsModalOpenAguardando(false);
                setInputValue("");
              }}
            >
              Fechar
            </button>
          </div>
        </div>
      )}

      {isModalOpenAnalise && (
        <div className={styles.modalProducaoForm}>
          <div className={styles.modalContentProducaoForm}>
            <div
              className={styles.closeForm}
              onClick={() => setIsModalOpenAnalise(false)}
            >
              &times; Fechar
            </div>
            <h2>Conteúdo da Análise de Perfil</h2>
            <p>Visualização da análise não configurada nesta tela.</p>
          </div>
        </div>
      )}

      {isModalOpenForm && (
        <div className={styles.modalProducaoForm}>
          <div className={styles.modalContentProducaoForm}>
            <div
              className={styles.closeForm}
              onClick={() => setIsModalOpenForm(false)}
            >
              <FaTimes /> Fechar
            </div>
            <a href={`${origin}/preencher/${currentFormId}`}>
              <div
                className={styles.closeForm}
                style={{ backgroundColor: "var(--corOn)", color: 'black' }}
              >
                <FaPen /> Editar
              </div>
            </a>
            <h2>Conteúdo da DS-160</h2>
            <p>Form ID: {currentFormId}</p>
            <div>{renderFormContent(currentFormContent)}</div>
          </div>
        </div>
      )}

      <ModalFinalizar
        open={isModalOpenFinalizado}
        onClose={() => setIsModalOpenFinalizado(false)}
        onSubmit={handleSubmitFinalizado}
        login={login}
        setLogin={setLogin}
        senha={senha}
        setSenha={setSenha}
        inputValue={inputValue}
        setInputValue={setInputValue}
        textareaRef={textareaRef}
      />
    </div>
  );
}

export default Producao;